import { cn } from "@/common/utils/cn";
import { ClassNamesConfig, StylesConfig } from "react-select";

export const styles: StylesConfig<unknown> = {
  option: (styles, { isSelected, isFocused,  }) => ({
    ...styles,
    backgroundColor:
      isSelected
      ? '#0C8CE9'
      : isFocused
      ? '#f1f1f1'
      : undefined,
    color: isFocused && !isSelected ? 'black' : 'white',
    minHeight: '32px',
  }),
  indicatorSeparator: () => ({
    display: 'none'
  }),
  control: (styles, { hasValue }) => ({
    ...styles,
    backgroundColor: hasValue ? '#49565C' : ''
  }),
  menuPortal: (styles) => ({ ...styles, zIndex: 99999 }),
}

export const controlStyles: ClassNamesConfig<unknown> = {
  placeholder: () => 'text-gray-400 text-sm',
  control: () => 'p-2 w-full rounded-md !min-h-[52px] !bg-neutral-op-8 outline-none !border-none',
  indicatorsContainer: () => 'mb-auto',
  container: () => 'w-full !border-none !outline-none',
  menu: () => '!bg-[#383838] group select-menu text-xs !z-[9999] !pointer-events-auto',
  singleValue: () => '!text-white-800 text-sm',
  input: () => '!text-white-800 text-sm',
  valueContainer: () => 'gap-1',
  multiValue: () => 'bg-white-200 rounded-l-sm',
  multiValueLabel: () => '!text-white-800 font-medium !rounded-none px-1.5',
  multiValueRemove: ({ isDisabled }) => cn('bg-black rounded-0 !rounded-none w-7 flex items-center justify-center', isDisabled && 'hidden'),
  dropdownIndicator: ({ isDisabled }) => cn('text-white-800 hover:text-white-300 cursor-pointer', isDisabled && 'hidden'),
  clearIndicator: () => 'text-white-800 hover:text-white-300 cursor-pointer',
  option: ({ isSelected, isFocused }) =>
    cn('bg-[#383838] text-white-800 cursor-pointer', {
      'bg-[#444444] text-white-800': isFocused,
      'bg-blue-700 text-white-800': isSelected && !isFocused,
      'bg-blue-700/80 text-white-800': isSelected && isFocused,
    }),
}

export const disabledControlStyles: ClassNamesConfig<unknown> = {
  ...controlStyles,
  singleValue: () => '!text-white-300 text-sm',
}

export const badgeControlStyles: ClassNamesConfig<unknown> = {
  control: () => 'w-full !flex !min-h-[32px] !h-[32px] !justify-center !rounded-xl outline-none !border-none px-2',
  container: () => 'w-full !border-none !outline-none',
  indicatorsContainer: () => '!h-8',
  menu: () => '!bg-[#383838] text-xs !z-[9999] !pointer-events-auto',
  valueContainer: () => '!py-0',
  singleValue: () => '!text-white-800',
  placeholder: () => '!text-white-800 italic',
  input: () => 'text-white-400',
  option: ({ isSelected, isFocused }) =>
    cn('bg-[#383838] text-white-800 cursor-pointer', {
      'bg-[#444444] text-white-800': isFocused,
      'bg-blue-700 text-white-800': isSelected && !isFocused,
      'bg-blue-700/80 text-white-800': isSelected && isFocused,
    }),
}

export const reportsControlStyles: ClassNamesConfig<unknown> = {
  ...controlStyles,
  control: () => 'p-2 w-full rounded-md rounded-r-none !min-h-[52px] !bg-neutral-op-8 outline-none !border-none',
}
